import { render } from "./Divider.vue?vue&type=template&id=7ed0ce50"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Divider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed0ce50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed0ce50', __exports__)) {
    api.reload('7ed0ce50', __exports__)
  }
  
  module.hot.accept("./Divider.vue?vue&type=template&id=7ed0ce50", () => {
    api.rerender('7ed0ce50', render)
  })

}


export default __exports__